import React from "react";
import classNames from "classnames";
import T from "prop-types";
import ClipboardCopy from "MODULES/shared/components/ClipboardCopy";
import { Link } from "react-router-dom";
import { trim } from "lodash";

import { PartStatsTooltip } from "MODULES/shared/components";
import { renderIf } from "MODULES/shared/decorators";
import { getPartNumberColorClassNameByTierType } from "MODULES/shared/helpers";

function PartNumber({
  part,
  statsTooltip,
  className,
  showIcon,
  icon,
  showClipBoard
}) {
  const classes = classNames(
    "align_middle",
    getPartNumberColorClassNameByTierType(part.tier_type)
  );

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        whiteSpace: "nowrap"
      }}
    >
      <Link
        onClick={e => e.stopPropagation()}
        to={`/parts/${part.uuid || part.id}`}
        className={className}
      >
        {showIcon && <React.Fragment>{icon}</React.Fragment>}
        <span className={classes}>{trim(part.part_number)}</span>
      </Link>
      {showClipBoard && (
        <span
          onClick={e => e.stopPropagation()}
          style={{ paddingLeft: 5, display: "inline-block" }}
        >
          <ClipboardCopy name={trim(part.part_number)} type="Part" />
        </span>
      )}
      {statsTooltip && (
        <span className="align-middle" style={{ paddingLeft: 5 }}>
          <PartStatsTooltip part={part} />
        </span>
      )}
    </div>
  );
}

PartNumber.propTypes = {
  part: T.shape({
    id: T.number.isRequired,
    part_number: T.string.isRequired
  }).isRequired,
  statsTooltip: T.bool,
  className: T.string,
  showIcon: T.bool,
  icon: T.element
};

PartNumber.defaultProps = {
  statsTooltip: true,
  showIcon: false
};

const ifHasPartValues = renderIf(
  ({ part }) => part && Object.keys(part).length
);

export default ifHasPartValues(PartNumber);



// WEBPACK FOOTER //
// ./app/modules/shared/components/PartNumber/PartNumber.jsx